/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { RestoreJobType } from '../models/RestoreJobType';

export class ListRestoreJobTypesResponse {
  'restoreJobTypes': Array<RestoreJobType>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreJobTypes",
      "baseName": "restoreJobTypes",
      "type": "Array<RestoreJobType>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListRestoreJobTypesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

